import { FC, PropsWithChildren } from 'react';
import { IntlProvider } from 'react-intl';
import { useLang } from './I18nConfig';
import { de, en, es, fr, ja, zhHans, zhHant, id, vn } from './translations';

export const allMessages: Record<string, Record<string, string>> = {
  de,
  en,
  es,
  fr,
  ja,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
  id,
  vi: vn,
};

export const I18nProvider: FC<PropsWithChildren> = ({ children }) => {
  const locale = useLang();
  const messages = allMessages[locale];

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  );
};
